import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { AiDeleteQuestionChangeStrategy } from '../../../../bases';
import { AnswerItem } from '../components';
import styled from '@xstyled/styled-components';
import { getSize } from '@lib/common';
import { MathEnabledTextComponent } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledMatchingAnswersContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  width: 100%;\n"])), getSize('padding8'));
var StyledSubQuestionBefore = styled(MathEnabledTextComponent)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 400;\n  color: #ef4444;\n  text-decoration: line-through;\n  background-color: #fef2f2;\n  padding: 0 4px;\n  border-radius: 2px;\n  line-height: 1.5;\n  *,\n  p {\n    text-decoration: line-through !important;\n    color: #ef4444 !important;\n    display: inline;\n  }\n"])), getSize('typo14'));
var StyledAnswerPillBefore = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: #ef4444;\n  text-decoration: line-through;\n  background-color: #fef2f2;\n  border-radius: 2px;\n  padding: 0 4px;\n  font-size: inherit;\n  font-weight: 600;\n"])));

function getAnswerText(q, subQuestionId) {
  var _find, _find2;

  if (!q) return undefined;
  var answerId = (_find = ((q === null || q === void 0 ? void 0 : q.correctAnswers) || []).find(function (ca) {
    return ca.subQuestionId === subQuestionId;
  })) === null || _find === void 0 ? void 0 : _find.answerId;
  if (!answerId) return undefined;
  return (_find2 = ((q === null || q === void 0 ? void 0 : q.answers) || []).find(function (a) {
    return a.id.toString() === answerId;
  })) === null || _find2 === void 0 ? void 0 : _find2.description;
}

export var MatchingDeleteQuestionStrategy = /*#__PURE__*/function (_AiDeleteQuestionChan) {
  _inherits(MatchingDeleteQuestionStrategy, _AiDeleteQuestionChan);

  var _super = _createSuper(MatchingDeleteQuestionStrategy);

  function MatchingDeleteQuestionStrategy(context) {
    _classCallCheck(this, MatchingDeleteQuestionStrategy);

    return _super.call(this, context);
  }

  _createClass(MatchingDeleteQuestionStrategy, [{
    key: "renderSubQuestions",
    value: function renderSubQuestions() {
      var _before$subQuestions;

      var before = this.context.before;
      var subQuestions = (_before$subQuestions = before === null || before === void 0 ? void 0 : before.subQuestions) !== null && _before$subQuestions !== void 0 ? _before$subQuestions : [];
      if (subQuestions.length === 0) return null;
      return /*#__PURE__*/_jsx(StyledMatchingAnswersContainer, {
        children: subQuestions.map(function (sub, idx) {
          var _before$index, _sub$description;

          var answerText = getAnswerText(before, sub.id.toString());
          return /*#__PURE__*/_jsx(AnswerItem, {
            index: ((_before$index = before === null || before === void 0 ? void 0 : before.index) !== null && _before$index !== void 0 ? _before$index : 1) + idx,
            values: {
              description: /*#__PURE__*/_jsx(StyledSubQuestionBefore, {
                value: (_sub$description = sub.description) !== null && _sub$description !== void 0 ? _sub$description : ''
              }),
              isSelected: !!answerText,
              answerPill: answerText ? /*#__PURE__*/_jsx(StyledAnswerPillBefore, {
                children: answerText
              }) : undefined
            }
          }, sub.id.toString());
        })
      });
    }
  }]);

  return MatchingDeleteQuestionStrategy;
}(AiDeleteQuestionChangeStrategy);